import { render, staticRenderFns } from "./TargetDetailsTable.vue?vue&type=template&id=6cf82dfc&scoped=true"
import script from "./TargetDetailsTable.vue?vue&type=script&lang=js"
export * from "./TargetDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./TargetDetailsTable.vue?vue&type=style&index=0&id=6cf82dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf82dfc",
  null
  
)

export default component.exports